import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendSingleRequest } from '../../apis';
import {
  Button,
  CheckboxButton,
  Dropdown,
  Input,
  Subtitle,
  Title,
} from '../../components/shared';
import {
  updateUserMeta,
  updateUserSetting,
} from '../../store/auth/auth.actions';
import { showFeedback } from '../../store/ui/ui.actions';
import { useWidth } from '../../lib/useWidth';
import { isEmailFormat } from '../../lib/common.helpers';
import {
  selectProfile,
  selectSettings,
  selectUserMeta,
} from '../../store/auth/auth.selector';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';

const EmailPreference = () => {
  const width = useWidth();
  const dispatch = useDispatch<any>();
  const userMeta = useSelector(selectUserMeta);
  const profile = useSelector(selectProfile);
  const settings = useSelector(selectSettings);
  const lang = useSelector(selectLang);

  const [emails, setEmails] = useState(settings.friend_emails?.join(',') ?? '');
  const [disabled, setDisabled] = useState(false);

  const updatePreference = async (val: boolean) => {
    setDisabled(true);
    const response = await sendSingleRequest(
      { email_preference: { preference: val } },
      'POST',
      `api/user-meta`,
      true,
    );
    if (response.status) {
      await dispatch(updateUserMeta());
    }
    setDisabled(false);
  };
  const updateReminderType = async (val: string) => {
    setDisabled(true);
    const response = await sendSingleRequest(
      {
        email_preference: { ...userMeta?.email_preference, reminder_type: val },
      },
      'POST',
      `api/user-meta`,
      true,
    );
    if (response.status) {
      await dispatch(updateUserMeta());
    }
    setDisabled(false);
  };

  const saveEmailsList = async () => {
    if (emails && emails.split(',').some(x => !isEmailFormat(x))) {
      dispatch(
        showFeedback({
          isMessage: true,
          type: 'error',
          message: translate(lang, '_invalid_emails'),
        }),
      );
      return;
    }
    setDisabled(true);
    const data = emails ? emails.split(',') : [];
    const res = await dispatch(updateUserSetting('friend_emails', data));
    setDisabled(false);
    if (res === true) {
      dispatch(
        showFeedback({
          isMessage: true,
          type: 'success',
          message: translate(lang, '_email_list_updated_ok'),
        }),
      );
    } else {
      dispatch(
        showFeedback({
          isMessage: true,
          type: 'error',
          message: translate(lang, res),
        }),
      );
    }
  };

  return (
    <div className='content pb-32'>
      <div className='pb-32'>
        {width > 768 && (
          <Title
            className='mb-24'
            size={5}
            color='black-3'
            align='default'
            fontWeight={700}
          >
            {translate(lang, 'Email Preference')}
          </Title>
        )}
        <div className='mt-32'>
          <Subtitle size={1} color='black-3' align='left' fontWeight={500}>
            {profile?.email}
          </Subtitle>
        </div>
        <div className='mt-17 mb-17'>
          <CheckboxButton
            label={translate(
              lang,
              userMeta?.email_preference?.preference
                ? 'Subscribed'
                : 'Unsubscribed',
            )}
            checked={userMeta?.email_preference?.preference}
            onChange={e => updatePreference(e.target.checked)}
          />
        </div>
        {!!userMeta?.email_preference?.preference && (
          <div className='mb-32'>
            <Dropdown
              label={translate(lang, 'Reminder type')}
              options={[
                {
                  id: 'every',
                  value: 'every',
                  label: translate(lang, 'Every action'),
                },
                {
                  id: 'daily',
                  value: 'daily',
                  label: translate(lang, 'Group by daily'),
                },
              ]}
              value={userMeta?.email_preference?.reminder_type ?? undefined}
              onChange={v => updateReminderType(v)}
            />
          </div>
        )}
      </div>
      <div className='mt-64'>
        <div className='mt-17 mb-17'>
          <Input
            label={translate(lang, 'Email list')}
            type='textarea'
            onChange={e => setEmails(e.target.value)}
            value={emails}
            placeholder={translate(lang, '_enter_emails_separate_comma')}
          />
        </div>
        <div className='modal-button d-flex justify-end align-center'>
          <Button
            width={'small'}
            size={2}
            type='fill'
            color='green'
            className='rsp-btn ml-16'
            onClick={saveEmailsList}
            disabled={disabled}
          >
            {translate(lang, 'Confirm')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmailPreference;
